import { createSelector } from 'reselect';

import { userSelector } from '../reducers/current-user-selectors';
import { RequestState } from '../reducers/utils/state-manager';

import { sortAlphabetically, SORT_ORDER } from '../util/sort-functions';

export type AccountGroupState = {
  accountGroupsById: { [accountGroupId: number]: AccountGroup };
  accountGroupsStateById: { [accountGroupId: number]: RequestState };
  accountGroupsStateByUsername: { [username: string]: RequestState };
};
type State = { accountGroups: AccountGroupState };

const accountGroupsByIdSelector = (state: State) => state.accountGroups.accountGroupsById;

export const accountGroupsForIdSelector = createSelector(
  [accountGroupsByIdSelector, (_state: State, accountGroupId: number) => accountGroupId],
  (accountGroupsById, accountGroupId) => accountGroupsById[accountGroupId],
);

const accountGroupsStateByIdSelector = (state: State) => state.accountGroups.accountGroupsStateById;
export const accountGroupsStateForIdSelector = createSelector(
  [accountGroupsStateByIdSelector, (_state: State, id: number) => id],
  (accountGroupsStateById, id) => accountGroupsStateById[id],
);

const accountGroupsSelector = createSelector([accountGroupsByIdSelector], (accountGroupsById) =>
  Object.values(accountGroupsById),
);

export const accountGroupsForAdminSelector = createSelector(
  [accountGroupsSelector, userSelector],
  (accountGroups, user) =>
    user.isAdmin ? accountGroups.sort(sortAlphabetically(({ name }) => name, SORT_ORDER.ASC)) : [],
);

export const accountGroupsForUsernameSelector = createSelector(
  [accountGroupsSelector, (_state: State, username: string) => username],
  (accountGroups, username) =>
    accountGroups.filter((s) => s.Users.find((u) => u.username === username)),
);

const accountGroupsStateByUsernameSelector = (state: State) =>
  state.accountGroups.accountGroupsStateByUsername;
export const accountGroupsStateForUsernameSelector = createSelector(
  [accountGroupsStateByUsernameSelector, (_state: State, username: string) => username],
  (accountGroupsStateByUsername, username) => accountGroupsStateByUsername[username],
);
